export const AUTH_ROOT_ROUTE: string[] = ['auth'];

export const AUTH_SIGN_UP_ROUTE = [...AUTH_ROOT_ROUTE, 'signup'];
export const AUTH_VERIFY_EMAIL_ROUTE = [...AUTH_ROOT_ROUTE, 'verify-email'];
export const AUTH_LOGIN_ROUTE = [...AUTH_ROOT_ROUTE, 'login'];
export const AUTH_FORGOT_PASSWORD_ROUTE = [
  ...AUTH_ROOT_ROUTE,
  'forgot-password',
];
export const AUTH_RESET_PASSWORD_ROUTE = [...AUTH_ROOT_ROUTE, 'reset-password'];
